import { ApiClient } from '@/lib/axios/client';
import type { UserBotListing, CreateUserBotResponse, CreateUserBotInlineRequest, AddUserTasksInlineRequest, ParseUserBotResponse } from './types';

export class UserBotApi {
  static async listUserBots(orgId: string, includeSop?: boolean): Promise<UserBotListing> {
    const query = includeSop ? '?include_sop=true' : '';
    return await ApiClient.get<UserBotListing>(`/api/v1/orgs/${orgId}/user-bots${query}`);
  }

  static async createUserBot(orgId: string, name: string, file: File): Promise<CreateUserBotResponse> {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('file', file);
    return await ApiClient.post<CreateUserBotResponse>(`/api/v1/orgs/${orgId}/user-bots`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static async createUserBotInline(orgId: string, data: CreateUserBotInlineRequest): Promise<CreateUserBotResponse> {
    return await ApiClient.post<CreateUserBotResponse>(`/api/v1/orgs/${orgId}/user-bots/inline`, data);
  }

  static async getUserBotTemplate(orgId: string): Promise<Blob> {
    return await ApiClient.get<Blob>(`/api/v1/orgs/${orgId}/user-bots/template`, { responseType: 'blob' });
  }

  static async deleteUserBot(orgId: string, botCode: string): Promise<void> {
    return await ApiClient.delete<void>(`/api/v1/orgs/${orgId}/user-bots/${botCode}`);
  }

  static async addUserBotTasksInline(orgId: string, botCode: string, data: AddUserTasksInlineRequest): Promise<CreateUserBotResponse> {
    return await ApiClient.post<CreateUserBotResponse>(
      `/api/v1/orgs/${orgId}/user-bots/${botCode}/tasks/inline`,
      data
    );
  }

  static async parseUserTasks(orgId: string, file: File): Promise<ParseUserBotResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return await ApiClient.post<ParseUserBotResponse>(
      `/api/v1/orgs/${orgId}/user-bots/parse`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  static async addUserTasks(orgId: string, botCode: string, file: File): Promise<CreateUserBotResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return await ApiClient.post<CreateUserBotResponse>(
      `/api/v1/orgs/${orgId}/user-bots/${botCode}/tasks`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}
